import React from 'react';
import type { PersonalizationField, CartLinePersonalization } from '../types';

interface Props {
  fields: PersonalizationField[];
  values: CartLinePersonalization;
  onChange: (next: CartLinePersonalization) => void;
}

const PersonalizationFields: React.FC<Props> = ({ fields, values, onChange }) => {
  if (!fields?.length) return null;

  const setValue = (key: string, value: string) => {
    onChange({ ...values, [key]: value });
  };

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium">Personalization</div>
      {fields.map(f => (
        <div key={f.key} className="space-y-1">
          <label className="block text-xs text-text-light">
            {f.label}{f.required ? ' *' : ''}
          </label>
          {f.type === 'select' && f.options ? (
            <select
              className="w-full border border-background-dark rounded px-3 py-2 text-sm"
              value={values[f.key] ?? ''}
              onChange={e => setValue(f.key, e.target.value)}
              required={f.required}
            >
              <option value="">— select —</option>
              {f.options.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              className="w-full border border-background-dark rounded px-3 py-2 text-sm"
              maxLength={f.max_length ?? 60}
              value={values[f.key] ?? ''}
              onChange={e => setValue(f.key, e.target.value)}
              required={f.required}
            />
          )}
        </div>
      ))}
      <p className="text-xs text-text-light italic">
        Please double-check spelling. Personalized items are non-refundable once started.
      </p>
    </div>
  );
};

export default PersonalizationFields;
